import {Tabs} from "./Tabs";

export interface LayoutSwitchConfig {
    tabs: NodeListOf<HTMLElement>;
    content: NodeListOf<HTMLElement>;
}

export class LayoutSwitch extends Tabs {
    constructor({tabs, content}: LayoutSwitchConfig) {
        super({tabs, content});
    }

    protected onTabMouseLeave(): void {
        this.removeClassNames(this.elements.tabs);
        this.removeClassNames(this.elements.content);
    }

    protected removeClassNames(elements: NodeListOf<HTMLElement>): void {
        elements.forEach(it => it.classList.remove(`is-active`));
    }

    protected init(): void {
        const {tabs, content} = this.elements;
        if (!tabs.length || !content.length) return;
        tabs.forEach((tab) => {
            tab.addEventListener('mouseenter', (evt) => this.onTabClick(evt));
            tab.addEventListener('mouseleave', (evt) => this.onTabMouseLeave());
        });
    }
}